/**
 * Site Assessment checklist groups and items.
 *
 * NOTE: These labels are placeholders carried over from the original PDF forms.
 * Some may no longer be contextually relevant. Final copy should be reviewed
 * and confirmed with the team before implementation.
 *
 * Reused by:
 *   - application-site-assessment.vue (application form, editable)
 *   - site-assessment-modal.vue (admin review modal, read-only)
 */

export const SITE_ASSESSMENT_GROUPS = [
  {
    label: 'School Commitment & Requirements',
    items: [
      {
        key: 'school_informed_admin',
        label: 'The school is completely informed on the administrative commitments required to run the ACE program successfully.',
      },
      {
        key: 'school_informed_curriculum',
        label: 'The school is completely informed on the curriculum and training requirements needed to run the ACE program successfully.',
      },
    ],
  },
  {
    label: 'Dealer Commitment & Investment',
    items: [
      {
        key: 'dealer_strong_partner',
        label: 'The school has strong dealer partners to support and invest in the ACE program.',
      },
      {
        key: 'dealer_informed_committed',
        label: 'All sponsoring dealers are completely informed and committed to the level of support and engagement expected of them as ACE school partners.',
      },
      {
        key: 'dealer_top_techs_plus',
        label: 'All sponsoring dealers are enrolled in Top Techs+.',
      },
    ],
  },
  {
    label: 'Local TPS Support & Commitment',
    items: [
      {
        key: 'tps_identified_support',
        label: 'You have identified your local TPS and garnered their support to potentially add a new program location to the area.',
      },
      {
        key: 'tps_connected',
        label: 'The TPS has connected with both the school and all sponsoring dealerships involved.',
      },
    ],
  },
];

export const SITE_ASSESSMENT_KEYS = SITE_ASSESSMENT_GROUPS.flatMap(g => g.items.map(i => i.key));
